module.exports = __webpack_public_path__ + "img/tk.305febad.svg";